import { branchCount } from "./branchCount";
import {
  isEdge,
  isTask,
  isTimerEvent,
  isBranchNode,
  isEndNode,
  processTask,
  processTimerEvent,
  sortStats,
} from "./utils";

function isBranchEnd(item) {
  return item?.type === "parallelEnd" || item?.type === "conditionalEnd";
}

/**
 * Retorna o próximo item do fluxo a partir de um item final de branch.
 * Protege contra `null` e evita capturas de variáveis do loop.
 * @param {Elements} elements
 * @param {Node|Edge|null} lastItem
 * @returns {Node|Edge|null}
 */
function getNextItem(elements, lastItem) {
  if (!lastItem) return null;
  return elements.find((el) => el.source === lastItem.id) || null;
}

/**
 * Percorre um ramo do fluxo acumulando tempos e estatísticas.
 * Iterativo, sem recursão.
 * @param {Elements} elements
 * @param {Node|Edge} startItem
 * @returns {{
 *   branchTime: number,
 *   lastItem: Node|Edge|null,
 *   doneTime: number,
 *   donePreventTime: number,
 *   stats: Array,
 *   task: Object
 * }}
 */
export function checkBranch(elements, startItem) {
  let branchTime = 0;
  let doneTime = 0;
  let donePreventTime = 0;
  let stats = [];
  let task = {};
  let item = startItem;

  while (item) {
    const currentItem = item;

    if (isEdge(currentItem)) {
      item = elements.find((el) => el.id === currentItem.target) || null;
      continue;
    }

    if (isTask(currentItem)) {
      branchTime = processTask(currentItem, stats, branchTime);
      item = elements.find((el) => el.source === currentItem.id) || null;
      continue;
    }

    if (isTimerEvent(currentItem)) {
      branchTime = processTimerEvent(currentItem, stats, branchTime);
      item = elements.find((el) => el.source === currentItem.id) || null;
      continue;
    }

    if (isBranchNode(currentItem)) {
      const branchResult = branchCount(elements, currentItem, stats);

      branchTime += branchResult.max;
      doneTime += branchResult.maxDone;
      donePreventTime += branchResult.maxPreventDone;

      stats.push(...branchResult.stats);
      sortStats(stats);

      task = branchResult.task;
      item = getNextItem(elements, branchResult.lastItem);
      continue;
    }

    if (isEndNode(currentItem) || isBranchEnd(currentItem)) {
      return {
        branchTime,
        lastItem: currentItem,
        doneTime,
        donePreventTime,
        stats,
        task,
      };
    }

    item = elements.find((el) => el.source === currentItem.id) || null;
  }

  return { branchTime, lastItem: null, doneTime, donePreventTime, stats, task };
}
